import { VOICEX_URL_CONSTANTS } from "../../utils/constants";
import {
  DEFAULT_TENANT_ID,
  DEFAULT_WORKSPACE_ID,
  DEFAULT_USER_ID,
  US_TENANT_ID,
  US_WORKSPACE_ID,
  US_USER_ID,
  NURIX_WORKSPACE_ID,
  NURIX_TENANT_ID
} from "../../utils/constants";
/*
-- Images Female
1. https://retell-utils-public.s3.us-west-2.amazonaws.com/Marissa.png
2. https://retell-utils-public.s3.us-west-2.amazonaws.com/valeria.png
3. https://retell-utils-public.s3.us-west-2.amazonaws.com/Zuri.png
4. https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.png

-- Images Male
1. https://retell-utils-public.s3.us-west-2.amazonaws.com/bing.png
 */

/*
 Voice-Ids
 1. 11labs-Adrian
 3. 11labs-Andrew
 4. 11labs-Bing
 5. 11labs-Brian

 2. 11labs-Amy
 6. 11labs-Zuri
 7. 11labs-Nina
 8. 11labs-Myra
 9. 11labs-Marissa
*/

export const newAgentCategories = {
  Unifi: {
    path: "unifi",
    pageTitle: "Experience Our Voice AI Agents",
    pageCategory: "Unifi",
    agents: [
      {
        id: "18f5767c-2de8-4ea9-9827-77e90eb9bc57",
        name: "Recruitment Agent",
        description: "An agent that provides job details, schedules interviews, and enhances applicant engagement throughout the recruitment process.",
        subDescription: "An agent that provides job details, schedules interviews, and enhances applicant engagement throughout the recruitment process.",
        agentName: "Emily",
        icon: "https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.png",
        chatIcon: "https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.png",
        featureList: [
          "Provides Job Details",
          "Efficiently Schedules Interviews",
          "Enhances Applicant Engagement"
        ],
        voice: "true",
        chat: "false",
        callTitle: "Recruitment Agent",
        chatHints: [],
        callHintsTable: [],
        callHints: [],
        voiceInputs: [],
        voiceProvider: "retell",
        try_speaking: [],
        activities: [],
        phoneNumber: "070239",
        language: "English",
        default_voiceId: "default",
        voiceConfig: {},
        optional_voices: [
          {
            id: "default",
            name: "Emily",
            icon: "https://retell-utils-public.s3.us-west-2.amazonaws.com/nina.png",
            description: "Female Friendly & Instructive",
            language: "English",
            region: ""
          }
        ]
      }
    ]
  },
};
